import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { EyeOff, Home } from 'lucide-react'
import { usePageEnabled } from '@/hooks/use-client-ui'
import { useAuthStore } from '@/stores/auth'
import type { PageKey } from '@/types/api'

/**
 * 頁面開關守衛：admin 在 /admin/appearance 關閉的頁面顯示「暫停開放」。
 * admin 本人不受影響（否則關掉頁面後自己也看不到、無從預覽）。
 */
export function PageGate({ page, children }: { page: PageKey; children: ReactNode }) {
  const enabled = usePageEnabled(page)
  const role = useAuthStore((state) => state.user?.role)

  if (enabled || role === 'admin') {
    return <>{children}</>
  }

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center space-y-4">
          <EyeOff className="w-14 h-14 text-muted-foreground/70 mx-auto" />
          <h1 className="text-xl font-semibold text-foreground">暫停開放</h1>
          <p className="text-sm text-muted-foreground">
            這個功能目前暫停開放，請稍後再回來看看。
          </p>
          <Button asChild variant="outline" className="mx-auto w-fit">
            <Link to="/">
              <Home className="w-4 h-4 mr-2" />
              回到首頁
            </Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
